import { useNavigate, useParams } from "react-router-dom";
import { useGetInoutHistSel, useGetInoutInfo, useGetInoutSel, useSetInout } from "../../../../../interface/inout";
import styled from 'styled-components';
import theme from '../../../../../styles/theme';
import React, { useEffect, useState, useCallback } from "react";
import { FormControl, Select, InputLabel, TextField, MenuItem, FormLabel, RadioGroup, FormControlLabel, Radio, Autocomplete } from '@mui/material';
import Button from '../../../../common/Button';
import CommonDataGrid from "../../../../common/CommonDataGrid";
import moment from 'moment';
import MsgModal from "../../../../common/modal/MsgModal";
import FullModal from "../../../../common/modal/FullModal";
import InoutHistItem from "./InoutHistItem";
import { DetailWrap as ModifyWrap } from '../index'
import { Row } from "../../../../../styles/common";
import { useGetClientList, useGetCodeList, useGetUserList } from "../../../../../interface/common";
import { availCheck } from "../common";
import { useQuery } from 'react-query';
import { IOT_TP } from "../../../../common/constants";

const MainWrap = styled.div`
    padding: 0.25rem 1.5rem; 
    h3 {
        // display: inline-box;
        font-size: ${theme.fontSize.base};
        font-weight: 600;
        // width: calc(100% - 24px);
        margin: 0;
        
        color: ${theme.color.black};
    }
    div {
        // width: calc(100% - 24px);
        // padding: 12px;
        color: ${theme.color.black};
        font-size: ${theme.fontSize.base};
    }
    transition: ${theme.windowSize.drawerTransition};
`;

const columns = [
    { field: 'lot_no', headerName: '표기번호', width:100 },
    // { field: 'o_ret_stnm', headerName: '반출상태', flex:0.5 },
    { field: 'o_reg_dt', headerName: '반출일', width:145 },
    { field: 'o_reg_nm', headerName: '반출자', width:100 },
    { field: 'i_reg_dt', headerName: '반입일', width:145 },
    { field: 'i_reg_nm', headerName: '반입자', width:100 },
    { field: 'i_ret_stnm', headerName: '반입상태', width:100 },
    { field: 'tno', headerName: '자산번호', width:140},
    { field: 'cat_nm', headerName: '분류', width:100},
    { field: 'model_nm', headerName: '모델명', width:120 },
    { field: 'r_item', headerName: '연계자산', width:200 },
]

const InoutHistMain = ({}) => {

    const param = useParams();
    const navigate = useNavigate();

    const { data : user } = useQuery('ADMIN_USER_INFO', {});

    const [sendItem, setSendItem] = useState({});
    const [list, setList] = useState([]);
    const [errorMsg, setErrorMsg] = useState();
    const [toggle,setToggle] = useState(false);
    const [itemOpen,setItemOpen] = useState(false);
    const [targetSelect, setTargetSelect] = useState();
    const [modifyOpen,setModifyOpen] = useState(false);
    const [orgIsIng, setOrgIsIng] = useState();

    const [clientList, setClientList] = useState([]);
    const [uList, setUList] = useState([]);

    const { mutate, error } = useSetInout();
    const {data : iotTpList} = useGetCodeList('iot_tp');
    const {data : subTpList} = useGetCodeList('sub_tp');
    const { data: pItem, isSuccess, refetch: inoutInfoRefetch} = useGetInoutInfo({sno:param.sno});
    const { data: inoutList} = useGetInoutSel({});
    const { data, isLoading, refetch: inoutHistRefetch } = useGetInoutHistSel({sno:param.sno});

    const { data : cList} = useGetClientList();
    const {data : userList} = useGetUserList();

    useEffect(()=>{
        if(param){
            inoutInfoRefetch();
            inoutHistRefetch();
        }
    },[param])

    useEffect(()=>{
        if(isSuccess && pItem && pItem[0]){
            const target = pItem[0];
            setOrgIsIng(pItem[0].is_ing);
            console.log(target)
            setSendItem(target);
        }
    },[pItem])

    useEffect(()=>{
        if(data){
            setList(
                data.map((item,index)=>(
                    {
                        ...item,
                        id:index,
                        r_item: 
                            (item.r_tno && item.r_tno === null) ? 
                            (item.s_tno !== null) ? (item.s_tno +' | '+ ((item.s_lot_no !== null && item.s_lot_no) !== '' ? item.s_lot_no : '-')) : '-'
                            : 
                            (item.r_tno !== null) ? (item.r_tno +' | '+ ((item.r_lot_no !== null && item.r_lot_no) !== '' ? item.r_lot_no : '-')) : '-' ,
                        o_reg_dt:moment(item.o_reg_dt).format('YYYY/MM/DD HH:mm'),
                        i_reg_dt:(item.i_reg_dt && item.i_reg_dt!== null) ?moment(item.i_reg_dt).format('YYYY/MM/DD HH:mm') : '',
                    }
                    )));
        }else{
            setList([])
        }
    },[data])

    useEffect(()=>{
        if(cList){
            setClientList(cList.map((item,index)=>({
                ...item,
                label:item.cnm})
                ));
        }
    },[cList])

    useEffect(()=>{
        if(userList){
            setUList(userList.map((item,index)=>({
                ...item,
                label:item.user_nm})
                ));
        }
    },[userList])

    useEffect(()=>{
        if(error && error !== null && error.response && error.response.data){
            setErrorMsg(error.response.data.message)
        }
    },[error])

    const handleValueChange = (id, val) => {
        setSendItem({...sendItem,[id]:val});
    }

    const handleModClick = useCallback((param) => {
        mutate(
            {...param,mode:'PUT'},
            {
                onSuccess:()=>{
                    setToggle(true);
                    setErrorMsg('수정 되었습니다.');
                },
                onError:(e)=>{
                    setToggle(true);
                    setErrorMsg('수정 실패하였습니다.',e);
                }
            }
        );
        orgIsIng !== param.is_ing && (
        mutate(
            {...param,mode:'IS_ING'}
        ));
    },[mutate]);

    const handleDelClick = useCallback(() => {
        const delParam = {
            mode: 'DELETE',
            sno: param.sno
        }
        mutate(
            delParam,
            {
                onSuccess:()=>{
                    navigate('/admin/inout')
                },
                onError:(e)=>{
                    setToggle(true);
                    setErrorMsg('삭제 실패하였습니다.'+e);
                }
            }
            );
    },[mutate]);

    return (isSuccess && pItem[0]) ? (
        <MainWrap>
            <div 
                style={{
                    flexGrow:1,
                    display:'flex',
                    flexDirection:'column',
                    justifyContent:'flex-start'
                }}
            >

                <Row style={{marginTop:'8px',justifyContent:'flex-start'}}>
                    {/** 
                     <TextField
                        id='iot_nm'
                        label='작업명'
                        size='small'
                        // defaultValue={pItem[0].isp_nm}
                        value={sendItem.iot_nm}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                    */}
                        <TextField
                            id='iot_nm'
                            label='과업명'
                            size='small'
                            style={{width:'20rem'}}
                            // defaultValue={pItem[0].isp_nm}
                            value={sendItem.iot_nm}
                            disabled={!availCheck(user.user_tp)}
                            onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                        />
                        {/* <FormControl style={{width:'18rem'}} size='small'>
                            <InputLabel id='iotTp-label'>작업명</InputLabel>
                            <Select label="작업명" labelId='iotTp-label' size='small' defaultValue={param.sno}>
                                {inoutList && inoutList.map((item,index)=>{
                                    return <MenuItem 
                                                key={index} 
                                                value={item.sno} 
                                                onClick={()=>navigate('/admin/inout/'+item.sno+'/inoutDetail')}
                                            >
                                                {item.iot_nm}
                                            </MenuItem>
                                })}
                            </Select>
                        </FormControl> */}
                        {sendItem.iot_tp &&
                        <FormControl style={{width:'8rem'}} size='small'>
                            <InputLabel id='iotTp-label'>반출입유형</InputLabel>
                            <Select label="반출입유형" labelId='iotTp-label' size='small' value={sendItem && sendItem.iot_tp} disabled={!availCheck(user.user_tp)}>
                                <MenuItem value={''}>--------</MenuItem>
                                {iotTpList && iotTpList.map((item,index)=>{
                                    return <MenuItem 
                                                key={index} 
                                                value={item.code} 
                                                onClick={()=>handleValueChange('iot_tp',item.code)}
                                            >
                                                {item.value}
                                            </MenuItem>
                                })}
                            </Select>
                        </FormControl>
                        }
                        {sendItem.iot_tp === IOT_TP.SEARCH &&
                        <FormControl style={{width:'12rem'}} size='small'>
                            <InputLabel id='subTp-label'>유형</InputLabel>
                            <Select label="유형" labelId='subTp-label' size='small' value={sendItem && sendItem.sub_tp} disabled={!availCheck(user.user_tp)}>
                                {subTpList && subTpList.map((item,index)=>{
                                    return <MenuItem 
                                                key={index} 
                                                value={item.code} 
                                                onClick={()=>handleValueChange('sub_tp',item.code)}
                                            >
                                                {item.value}
                                            </MenuItem>
                                })}
                            </Select>
                        </FormControl>
                        }
                        <FormControl style={{width:'8rem'}} size='small'>
                            <InputLabel id='isIng-label'>작업상태</InputLabel>
                            <Select label="작업상태" labelId='isIng-label' size='small' defaultValue={pItem && pItem[0].is_ing} disabled={!availCheck(user.user_tp)}>
                                <MenuItem 
                                    value={1} 
                                    onClick={()=>handleValueChange('is_ing',1)}
                                >
                                    진행중
                                </MenuItem>
                                <MenuItem 
                                    value={0} 
                                    onClick={()=>handleValueChange('is_ing',0)}
                                >
                                    완료
                                </MenuItem>
                            </Select>
                        </FormControl>
                         {/* <TextField
                            id='iot_tpnm'
                            label='반출입유형'
                            size='small'
                            disabled={true}
                            // defaultValue={pItem[0].isp_nm}
                            value={sendItem.iot_tpnm}
                            onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                        /> */}
                        <TextField
                            id='reg_dt'
                            label='등록자'
                            size='small'
                            disabled
                            style={{width:'6rem'}}
                            // defaultValue={pItem[0].isp_nm}
                            value={sendItem.reg_nm}
                            onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                        />
                        <TextField
                            id='reg_dt'
                            label='등록일'
                            size='small'
                            disabled
                            type='date'
                            style={{width:'9rem'}}
                            // defaultValue={pItem[0].isp_nm}
                            value={sendItem && moment(sendItem.reg_dt).format('YYYY-MM-DD')}
                            onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                        />
                </Row>
                <Row>
                        {(clientList && clientList.length > 0) &&
                        <Autocomplete
                            id="cid"
                            size='small'
                            options={clientList}
                            sx={{ width: 320 }}
                            value={sendItem && sendItem.cnm}
                            renderInput={(params) => <TextField {...params} label="거래처" />}
                            onChange={(e,v)=>v!==null&&handleValueChange('cid',v.cid)}
                            />
                        }
                        {(uList && uList.length > 0) &&
                        <Autocomplete
                            id="work_id"
                            size='small'
                            options={uList}
                            sx={{ width: 130 }}
                            value={sendItem && sendItem.work_nm}
                            renderInput={(params) => <TextField {...params} label="작업자" />}
                            onChange={(e,v)=>v!==null&&handleValueChange('work_id',v.uid)}
                            />
                        }
                        <div style={{flexGrow:1}} />
                    {availCheck(user.user_tp) &&
                        <div style={{display:'grid', alignItems:'center', gridTemplateColumns:'100px 100px'}}>
                            <Button onClick={()=>handleModClick(sendItem)}>수정</Button>
                            <Button onClick={handleDelClick}>삭제</Button>
                        </div>
                    }
                </Row>
                <Row style={{display:'grid',gridTemplateColumns:'1fr 1fr'}}>
                    <TextField 
                        id='contents' 
                        label='조사내용' 
                        fullWidth 
                        multiline 
                        // disabled
                        rows={4} 
                        size='small' 
                        InputLabelProps={{shrink:true}} 
                        value={sendItem.contents}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                        disabled={!availCheck(user.user_tp)}
                    />
                    <TextField 
                        id='descr' 
                        label='비고' 
                        fullWidth 
                        multiline
                        // disabled 
                        rows={4} 
                        size='small' 
                        InputLabelProps={{shrink:true}} 
                        value={sendItem.descr}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                        disabled={!availCheck(user.user_tp)}
                    />
                </Row>
                {pItem && 
                <Row style={{justifyContent:'space-between'}}>
                    <div>전체 개수 : {list ? list.length : 0}</div>
                    {pItem[0].is_ing===1 && <Button onClick={()=>{setTargetSelect({});setItemOpen(true)}} style={{width:'170px'}}>자산 반출입 추가</Button>}
                </Row>
                }
                {pItem &&
                <div style={{width:'100%', height: '54vh'}}>
                <CommonDataGrid
                    isLoading={isLoading}
                    list={list}
                    columns={columns}
                    onRowClick={(e)=>{setTargetSelect(e.row);setItemOpen(true)}}
                />
                </div>
                }
                {
                <MsgModal open={toggle}>
                    <div style={{height:'100%',textAlign:'center',display:'flex',flexDirection:'column',justifyContent:'space-between'}} onClick={()=>setToggle(false)}>
                        <h2>{errorMsg}</h2>
                        <Button onClick={()=>setToggle(false)}>닫기</Button>
                    </div>
                </MsgModal>
            }
            {
                <FullModal open={modifyOpen}>
                    <ModifyWrap target={sendItem} onClose={setModifyOpen} />
                </FullModal>
            }
            {
                <FullModal open={itemOpen}>
                    <MngItem sno={pItem[0].sno} iotNm={pItem[0].iot_nm} isIng={pItem[0].is_ing} target={targetSelect} onClose={setItemOpen} />
                </FullModal>
            }
            </div>
        </MainWrap>
    ) : <React.Fragment />
}



const DetailWrapStyle = styled.div`
    width: 100%;
    height: 100%;
    // border: 1px solid red;
`;



const MngItem = ({sno, target, iotNm, isIng, onClose}) => {
    return (
        <DetailWrapStyle>
            <InoutHistItem sno={sno} iotNm={iotNm} isIng={isIng} target={target}  onClose={onClose} />
        </DetailWrapStyle>
    )

}


export default InoutHistMain;